jQuery(function ($) {
	const KEYCODE_ESC = 27;
	const KEYCODE_ENTER = 13;
	const KEYCODE_TAB = 9;
	const KEYCODE_SHIFT = 16;

	/*
	 * Navigation / site header scripts
	 */
	const menuToggleElement = $('#c-menu__toggle');
	const menuLabel = $('#c-menu__toggle-label');
	const menu = $('#c-menu');
	const menuOverlay = $('#c-menu__bg-overlay');
	const body = document.body;
	let isMenuShown = false;
    let scrollPosition = $(window).scrollTop();

	const transition = document.querySelector('#c-menu');

	// On load, if menu is close, remove hidden menu items from accessibility tree
	if (!isMenuShown) {
		menu.find('a, button, input').each(function() {
			$(this).attr('tabindex', '-1');
		});
	}

	function openMenu(){
		// Get current scroll position
		scrollPosition = $(window).scrollTop();
		body.style.top = `-${scrollPosition}px`;
		// Make menu visible
		menu.attr('aria-hidden', 'false');
		// Allow links in the menu to be keyboard focusable
		menu.find('a, button, input').each(function() {
			$(this).attr('tabindex', '0');
		});
		menuLabel.text('Close');
		body.classList.remove('state--nav-closed');
		body.classList.add('state--nav-open');
		menuToggleElement.attr('aria-expanded', true);
		trapFocus($('.js-trap-focus'), $('#menu-header-menu-primary .menu-item:first-of-type a'));
	}

	function closeMenu(){
		isMenuShown = false;
		menuLabel.text('Menu');
		body.classList.remove('state--nav-open');
		body.classList.add('state--nav-closed');
		menuToggleElement.attr('aria-expanded', false);
		trapFocus($('.js-trap-focus'), null);
		// Remove menu items from accessibility tree
		menu.find('a, button, input').each(function() {
			$(this).attr('tabindex', '-1');
		});
		// Hide menu after transform ends
		transition.addEventListener('transitionend', () => {
			menu.attr('aria-hidden', 'true');
		}, { once: true });
		// Return to scroll position
		body.style.position = '';
		body.style.top = '';
		window.scrollTo({
		  top: scrollPosition,
		  left: 0,
		  behavior: 'auto'
		});
	}

	// Toggle main menu visibility on button click
	menuToggleElement.click(function (e) {
		isMenuShown = !isMenuShown;
		if (isMenuShown) {
			openMenu();
		} else {
			closeMenu();
		}
	});

	menuOverlay.click(function (e) {
		closeMenu();
	});

	// Esc closes header menu
	$(document).keyup(function(e) {
		if (e.keyCode == KEYCODE_ESC) {
			closeMenu();
		}
	});


	/*
	* Config for focus trap
	*
	* @param parents - a collection of elements focus should be constrained to
	* @param elementToFocus - an element to focus when the trap is activated.
	* Focus trap will be removed when elementToFocus == null
	*/
	function trapFocus(parents, elementToFocus) {
		// find all focusable elements inside all parents passed to this function
		// note that the .find function searches through all the levels in the dom tree
		// If you want direct children only (because you have nested menus etc.), use .children(), or maybe a more specific selector
		const elements = parents.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');

		// firstElement / lastElement are used to tell if we need to loop our focus backwards or forwards
		const firstElement = elements[0];
		const lastElement = elements[elements.length - 1];

		if (elementToFocus) {
			// Trap on
			elementToFocus.focus();
			parents.on('keydown', handleKeydown);
		} else {
			// Trap off. Remove event listeners
			parents.off('keydown');
		}

		// Checking which key was pressed, handling looping etc
		function handleKeydown(e) {
			var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) {
				if (document.activeElement === firstElement) {
					lastElement.focus();
					e.preventDefault();
				}
			} else {
				if (document.activeElement === lastElement) {
					firstElement.focus();
					e.preventDefault();
				}
			}
		}
	}


});
